import { render, staticRenderFns } from "./alipay_h5.vue?vue&type=template&id=d47abbd0&scoped=true&"
import script from "./alipay_h5.vue?vue&type=script&lang=js&"
export * from "./alipay_h5.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d47abbd0",
  null
  
)

export default component.exports